<template>
  <div class="modalform">
    <v-dialog dark v-model="dialog" :width="420" persistent class="mt-4">
      <v-btn primary dark slot="activator" >Get Pre-approved</v-btn>
      <v-card light>
        <v-alert v-show="showFormMsg" :success="formSuccess" value="true" :error="formSuccess != true ">
          <div v-html="formMsg"></div>
        </v-alert>
        <v-card-title>
          <span class="headline">Get Pre-approved</span>
        </v-card-title>
        <v-card-text light>
          <v-text-field light label="First name" required v-model="first_name" :maxlength="60"></v-text-field>
          <v-text-field light label="Last name" required v-model="last_name" :maxlength="60"></v-text-field>
          <v-text-field light label="Email" type="email" max="15" :rules="[rules.required,rules.email]" v-model="email" :maxlength="60"></v-text-field>
          <v-text-field light label="Phone" :maxlength="60" v-model="phone"></v-text-field>
          <v-card light>
            <v-card-title>
              <v-chip label outline class="red red--text">Disclaimer and User Agreement*</v-chip>
              * Calculation results are approximations and for information purposes only. Rates used for calculations are not considered rate guarantees or offers. All loans are subject to standard credit approval.
            </v-card-title>
          </v-card>
          <v-checkbox label="I Agree" v-model="agree" light required></v-checkbox>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn light class="blue--text darken-1" flat @click.native="dialog = false">Close</v-btn>
          <v-btn light v-show="form_valid" class="blue--text darken-1" flat :loading="formSubInProgress" @click.native="submit_form">Send</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      dialog: false,
      rules: {
        required: (value) => !!value || 'Required.',
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      agree: false,
      formSubInProgress: false,
      showFormMsg: false,
      formSuccess: false,
      formMsg: '',
      serverErrors: '',
      IsServerErrors: 'false'
    }
  },
  props: ['vehicle_price', 'down_payment', 'loan_duration', 'interest_rate', 'monthly_payment'],
  computed: {
    form_valid: function () {
      let valid = []
      if (this.rules.required(this.first_name) !== true) {
        valid.push('1')
      }
      if (this.rules.required(this.last_name) !== true) {
        valid.push('1')
      }
      if (this.rules.required(this.email) !== true) {
        valid.push('1')
      }
      if (this.rules.email(this.email) !== true) {
        valid.push('1')
      }
      if (this.rules.required(this.agree) !== true) {
        valid.push('1')
      }
      return valid.length <= 0
    }
  },
  methods: {
    submit_form: function () {
      let api = 'http://fordtrinidad.com/index.php?id=28'
      let vi = this
      /*
      Here we set up our post variables to be sent as application/x-www-form-urlencoded (so they can be available via post) as axios
      sends data as a json string by default
       */
      var params = new URLSearchParams()
      params.append('first_name', this.first_name)
      params.append('last_name', this.last_name)
      params.append('email', this.email)
      params.append('phone', this.phone)
      params.append('vehicle_price', this.vehicle_price)
      params.append('down_payment', this.down_payment)
      params.append('loan_duration', this.loan_duration)
      params.append('interest_rate', this.interest_rate)
      params.append('monthly_payment', this.monthly_payment)
      this.formSubInProgress = true
      this.$axios({
        method: 'post',
        url: api,
        data: params,
        timeout: 2000
      })
      .then(function (response) {
        if (response.data.success) {
          vi.setupFormFeedback(false, true, true, 'Your request has been submitted for approval')
          vi.clearForm()
        } else {
          console.log(response.data.message)
          vi.setupFormFeedback(false, true, false, response.data.message)
        }
      })
      .catch(function () {
        vi.setupFormFeedback(false, true, false, 'An error has occurred please try again.')
      })
    },
    setupFormFeedback: function (formSubInProgress, showFormMsg, formSuccess, formMsg) {
      this.formSubInProgress = formSubInProgress
      this.showFormMsg = showFormMsg
      this.formSuccess = formSuccess
      this.formMsg = formMsg
    },
    clearForm: function () {
      this.first_name = ''
      this.last_name = ''
      this.email = ''
      this.phone = ''
      this.agree = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// modalForm.vue?193c333e